import { generateUtilityClasses, styled } from '@mui/material';
import { ResponsiveContainer } from 'recharts';

export const COMPONENT_NAME = 'PrcBaseChart';

export const baseChartClasses = {
  ...generateUtilityClasses(COMPONENT_NAME, ['axisLabel']),
};

export const Root = styled(ResponsiveContainer)(({ theme }) => ({
  '& .recharts-cartesian-axis-tick-value': {
    ...theme.typography.caption,
    fill: theme.palette.text.primary,
  },
  '& .recharts-legend-item': {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
    marginRight: '16px!important',
  },
  [`& .${baseChartClasses.axisLabel}`]: {
    ...theme.typography.caption,
  },
}));
